import { ActionCategory } from "@sablier/v2-constants";
import { _ } from "@sablier/v2-mixins";
import type { IAddress, IValue } from "@sablier/v2-types";
import Token from "../Token";

type Params = {
  id: string;
  chainId: number;
  /* --------------- */
  addressA?: string;
  addressB?: string;
  amountA?: string;
  amountB?: string;
  category: string | ActionCategory;
  from: string;
  /* --------------- */
  block?: string;
  hash?: string;
  timestamp?: string;
};

export type Preview = {
  timestamp?: string;
};

export default class Action {
  readonly id: string;
  readonly chainId: number;
  /* --------------- */
  readonly addressA?: IAddress;
  readonly addressB?: IAddress;
  readonly amountA: IValue;
  readonly amountB: IValue;
  readonly category: ActionCategory;
  readonly from: IAddress;
  readonly token: Token;
  /* --------------- */
  block?: string;
  hash?: string;
  timestamp?: string;

  constructor(params: Params, token: Token) {
    this.id = params.id;
    this.chainId = params.chainId;
    this.token = token;
    /* --------------- */
    this.addressA = params.addressA;
    this.addressB = params.addressB;
    this.amountA = _.toValue({
      decimals: token.decimals,
      raw: params.amountA,
    });
    this.amountB = _.toValue({
      decimals: token.decimals,
      raw: params.amountB,
    });
    this.category = _.capitalize(params.category) as ActionCategory;
    this.from = params.from;
    /* --------------- */

    this.block = params.block;
    this.hash = params.hash;
    this.timestamp = _.toValuePrepared({
      humanized: params.timestamp,
      decimals: 3,
    });
  }
}
